export default {
  'Start at': 'Démarrer à',
  'Set to current time': "Réglage sur l'heure actuelle",
  'Audio volume': 'Volume du son',
  'Video volume': 'Volume du vidéo',
  'Trim audio': 'Couper le son',
  'Audio will end with the video': "L'audio se terminera avec la vidéo.",
  'Trim': 'Découpage',
}